import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "@phosphor-icons/react";
import { api, apiError } from "@/lib/api";

// Centang admin: kecualikan reservasi/pesanan ini dari pembatalan otomatis (mis. pasien janji bayar tunai di klinik).
export const NoAutoCancelToggle = ({ kind, id, initial }) => {
  const [on, setOn] = useState(!!initial);
  const [busy, setBusy] = useState(false);
  const toggle = async (value) => {
    setBusy(true);
    try {
      await api.post(`/admin/${kind === "order" ? "orders" : "reservations"}/${id}/no-auto-cancel`, { value });
      setOn(value);
      toast.success(value ? "Tidak akan dibatalkan otomatis" : "Pembatalan otomatis berlaku lagi");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <label data-testid="no-auto-cancel-toggle" className="flex cursor-pointer items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
      <input data-testid="no-auto-cancel-checkbox" type="checkbox" checked={on} disabled={busy} onChange={(e) => toggle(e.target.checked)} className="mt-0.5" />
      <span><ShieldCheck size={15} className="mr-1 inline" /><b>Jangan batalkan otomatis</b><span className="block text-xs text-amber-700">Centang bila pasien sudah janji bayar di klinik. Reservasi tidak akan dibatalkan walau batas waktu pembayaran lewat.</span></span>
    </label>
  );
};
